import { render, staticRenderFns } from "./CanvasModal.vue?vue&type=template&id=144a127a&"
import script from "./CanvasModal.vue?vue&type=script&lang=js&"
export * from "./CanvasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports